// extracted by mini-css-extract-plugin
export default {"skeleton":"MyPageLoading_skeleton__begHD","shimmer":"MyPageLoading_shimmer__JwK2W"};